export default function isProd() {
  return window.location.hostname === 'admin.luxuryescapes.com';
}
